import React from "react";
import PropTypes from "prop-types";
import { FormInputGroup } from "../../../react/form_input_group";
import { StripePaymentRow } from "./stripe_payment_row.js.jsx";

export const StripePaymentForm = ({
  name,
  email,
  nameError,
  emailError,
  stripeError,
  onChange,
  onAddressChange,
  initialBillingAddress,
  isEventFree,
  cartTotal,
  shouldCollectTax
}) => {
  const renderRequired = () => <span className="required">REQUIRED</span>;

  return (
    <FormInputGroup className="payment-group-wrap">
      {isEventFree ? (
        <legend className="em-section_register_title">
          Contact Information
        </legend>
      ) : (
        <legend className="em-section_register_title">
          Billing Contact
        </legend>
      )}
      <div className="em-attendee_info">
        {!shouldCollectTax && <div className="em-input_container">
          <div
            className={
              nameError === "required"
                ? "em-input-floating em-error"
                : "em-input-floating"
            }
          >
            <input
              type="text"
              id="billing-name"
              name="name"
              autoComplete="name"
              required="required"
              onChange={onChange}
              value={name}
              placeholder="Full Name"
            />
            <label htmlFor="billing-name">
              Name {renderRequired()}
            </label>
          </div>
          {nameError === "required" && (
            <span className="error_marker" role="alert">
              The name is required
            </span>
          )}
        </div>}
        <div className="em-input_container">
          <div
            className={
              emailError
                ? "em-input-floating em-error"
                : "em-input-floating"
            }
          >
            <input
              type="text"
              id="billing-email"
              name="email"
              autoComplete="email"
              required="required"
              onChange={onChange}
              value={email}
              placeholder="Email Address"
            />
            <label htmlFor="billing-email">
              Email Address {renderRequired()}
            </label>
          </div>
          {emailError === "required" && (
            <span className="error_marker" role="alert">
              The email is required
            </span>
          )}
          {emailError === "invalid_format" && (
            <span className="error_marker" role="alert">
              That is not a valid email
            </span>
          )}
        </div>
      </div>

      {cartTotal > 0 && (
        <StripePaymentRow
          name={name}
          errors={stripeError}
          onNameChange={onChange}
          onAddressChange={onAddressChange}
          showAddress={shouldCollectTax}
          initialBillingAddress={initialBillingAddress}
        />
      )}
    </FormInputGroup>
  );
};

StripePaymentForm.propTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  nameError: PropTypes.string,
  emailError: PropTypes.string,
  stripeError: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  shouldCollectTax: PropTypes.bool.isRequired,
  isEventFree: PropTypes.bool.isRequired,
  cartTotal: PropTypes.number.isRequired
};
